module.exports = __webpack_public_path__ + "static/media/telgani_logo_color.ad016551.png";